import { useThemeStore } from '@/stores/themeStore'
import { darkCandleColors, darkChartTheme } from '@/styles/themes/dark'
import { lightCandleColors, lightChartTheme } from '@/styles/themes/light'

export function useChartTheme() {
  const theme = useThemeStore((s) => s.theme)
  return {
    chartOptions: theme === 'dark' ? darkChartTheme : lightChartTheme,
    candleColors: theme === 'dark' ? darkCandleColors : lightCandleColors,
    isDark: theme === 'dark',
  }
}
